<template>
    <div class="table-content">
        <div class="table">
            <el-table :ref="tag" :key="tag" v-loading="tableIsLoading" :data="tableList" height="100%" max-height="100%" :show-summary="true" :summary-method="getSummaries" border @sort-change="sortChange" @row-dblclick="jumpDetails">
                <el-table-column type="index" align="center" width="40" fixed>
                    <template slot="header">
                        <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                            <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column :label="item.label" fixed :prop="item.prop" min-width="140" v-for="(item,index) in tableHeaderList" :key="index">
                    <template slot-scope="scope">
                        <div v-if="item.prop == 'domainName'">{{scope.row.domainName}}{{scope.row.smallDomainDesc ? ('/' + scope.row.smallDomainDesc) : ''}}</div>
                        <div v-else>{{scope.row[item.prop]}}</div>
                    </template>
                </el-table-column>
                <!-- 自定义列：按弹窗保存的顺序渲染（支持拖动排序），列头/宽度/排序取自 customColumnMeta -->
                <el-table-column v-for="item in sortedCustomColumn" :key="item.prop"
                    :label="item.label" :prop="item.prop"
                    :width="getColumnWidth(item.prop)"
                    :sortable="customColumnMeta[item.prop] && customColumnMeta[item.prop].sortable ? 'custom' : false">
                    <template slot="header" v-if="customColumnMeta[item.prop] && customColumnMeta[item.prop].tip">
                        <span>{{ item.label }}</span>
                        <el-tooltip effect="light" :content="customColumnMeta[item.prop].tip" placement="top">
                            <i class="iconfont icon-a-bangzhu2" style="color: #ff8940;"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 原硬编码列已改为上方 sortedCustomColumn 动态渲染（列宽/列头提示见 customColumnMeta） -->
                <!-- <el-table-column label="小单位总数量" v-if="customColumnList['invAvgNum']" prop="invAvgNum" width="130" sortable="custom"></el-table-column>
                <el-table-column label="总重量" v-if="customColumnList['weightAllStr']" prop="weightAllStr" width="110" sortable="custom"></el-table-column> -->


                <el-table-column v-for="(item, index) in isLargessList" :key="item.prop" :label="item.label" :prop="item.prop"></el-table-column>
            </el-table>
        </div>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
import { exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    props: {
        tag: String,
        arguments: Object,
        tableHeaderList: Array,
        customColumnsList:Array,
        funcCode: Number,
        transmitQuery:Object
    },
    data() {
        return {
            tableIsLoading: false,
            tableList: [],
            summaries: {},
            tableColumnList: [],
            params: this.arguments,
            total: 0,
            // customColumnsList: [{
            //         label: "销售数量",
            //         prop: "saleQty",
            //     },
            //     {
            //         label: "销售金额",
            //         prop: "salTotalAmt",
            //     },
            //     {
            //         label: "退货数量",
            //         prop: "returnQty",
            //     },
            //     {
            //         label: "退货金额",
            //         prop: "returnTotalAmt",
            //     },
            //     {
            //         label: "还货数量",
            //         prop: "backQty",
            //     },
            //     {
            //         label: "还货金额",
            //         prop: "backTotalAmt",
            //     },
            //     {
            //         label: "净销售数量",
            //         prop: "netSaleQty",
            //     },
            //     {
            //         label: "净销售金额",
            //         prop: "netSaleTotalAmt",
            //     },
            //     {
            //         label: "成本金额",
            //         prop: "costPrice",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "毛利",
            //         prop: "crossProfit",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "毛利率",
            //         prop: "crossProfitMargin",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "换货数量",
            //         prop: "exchangeQty",
            //     },
            // ],
            allowCostPrice: false,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isSaleReport'
            },
            customColumn: [],
            isLargessList: [],
            // 自定义列元信息：顺序（用于无 sort 时的默认排序）、列宽、是否可排序、表头提示
            // 说明：列头文案与显隐仍以 customColumn（后端模板 + 页面配置）为准，此处只补渲染属性
            customColumnMeta: {
                itemSpec:             { index: 0,  width: 110 },
                invBarCode:           { index: 1,  width: 120 },
                midBarCode:           { index: 2,  width: 120 },
                salBarCode:           { index: 3,  width: 120 },
                saleQty:              { index: 4,  width: 110, sortable: true },
                saleDetailSalQtyFormat:{ index: 5, width: 150, sortable: true },
                saleDetailMidQtyFormat:{ index: 6, width: 150, sortable: true },
                saleDetailInvQtyFormat:{ index: 7, width: 150, sortable: true },
                sellWeightStr:        { index: 8,  width: 140, sortable: true },
                sellWeightStrTon:     { index: 9,  width: 140, sortable: true },
                salTotalAmt:          { index: 10, width: 110, sortable: true },
                sellCostPrice:        { index: 11, width: 130, sortable: true },
                returnQty:            { index: 12, width: 110, sortable: true },
                returnDetailSalQtyFormat:{ index: 13, width: 150, sortable: true },
                returnDetailMidQtyFormat:{ index: 14, width: 150, sortable: true },
                returnDetailInvQtyFormat:{ index: 15, width: 150, sortable: true },
                returnWeightStr:      { index: 16, width: 140, sortable: true },
                returnWeightStrTon:   { index: 17, width: 140, sortable: true },
                returnTotalAmt:       { index: 18, width: 110, sortable: true },
                backQty:              { index: 19, width: 110, sortable: true },
                backDetailSalQtyFormat:{ index: 20, width: 150, sortable: true },
                backDetailMidQtyFormat:{ index: 21, width: 150, sortable: true },
                backDetailInvQtyFormat:{ index: 22, width: 150, sortable: true },
                backWeightStr:        { index: 23, width: 140, sortable: true },
                backWeightStrTon:     { index: 24, width: 140, sortable: true },
                backTotalAmt:         { index: 25, width: 110, sortable: true },
                netSaleQty:           { index: 26, width: 120, sortable: true },
                netSalQtyFormat:      { index: 27, width: 160, sortable: true },
                netMidQtyFormat:      { index: 28, width: 160, sortable: true },
                netInvQtyFormat:      { index: 29, width: 160, sortable: true },
                netWeight:            { index: 30, width: 120, sortable: true },
                netWeightTon:         { index: 31, width: 120, sortable: true },
                netSaleTotalAmt:      { index: 32, width: 120, sortable: true },
                costPrice:            { index: 33, width: 106, sortable: true },
                saleInvAvgPrice:      { index: 34, width: 120, sortable: true },
                saleSalAvgPrice:      { index: 35, width: 120, sortable: true },
                crossProfit:          { index: 36, width: 80,  sortable: true },
                crossProfitMargin:    { index: 37, width: 90,  sortable: true },
                returnLv:             { index: 38, width: 140, sortable: true, tip: '退换货率：包括换货等其他单据' },
                returnMeetLv:         { index: 39, width: 140, sortable: true, tip: '净退货率 ：仅包括销售和退货' },
                exchangeQty:          { index: 40, width: 110, sortable: true },
                exchangeMeetQty:      { index: 41, width: 170, sortable: true },
                exchangeBackQty:      { index: 42, width: 170, sortable: true },
                // 客户/商品维度列表列（需求#154）
                serviceUserName:      { index: 43, width: 130 },
                customerEntryUserName:{ index: 44, width: 130 },
                customerLevel:        { index: 45, width: 100 },
                customerLabel:        { index: 46, width: 150 },
                settlementCustomerName:{ index: 47, width: 140 },
                isNewCustomerName:    { index: 48, width: 120 },
                isNewShopName:        { index: 49, width: 120 },
                customerStatus:       { index: 50, width: 100 },
                productLabelName:     { index: 51, width: 130 },
                productClassification:{ index: 52, width: 110 },
                isScatterProductName: { index: 53, width: 110 },
                priceBandLabelName:   { index: 54, width: 110 },
                isMaterialName:       { index: 55, width: 110 },
                countTankStatsName:   { index: 56, width: 130 },
                supplierName:         { index: 57, width: 130 }
            }
        }
    },
    computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        },
        // 按自定义列配置数组的顺序（即弹窗拖动后的顺序）渲染列；未在后端模板/Meta 中登记的列排在其后
        sortedCustomColumn() {
            const meta = this.customColumnMeta
            const indexed = this.customColumn
                .map((item, index) => ({ item, index }))
                .filter(row => meta[row.item.prop])
            indexed.sort((a, b) => {
                const sa = typeof a.item.sort === 'number' ? a.item.sort : this.getMetaIndex(a.item.prop)
                const sb = typeof b.item.sort === 'number' ? b.item.sort : this.getMetaIndex(b.item.prop)
                if (sa === sb) return a.index - b.index
                return sa - sb
            })
            return indexed.map(row => row.item)
        }
    },
    watch: {

    },
    created() {
        // this.getCustomColumnsList();
        let unwatch = this.$watch('$store.state.power', (val) => {
            if(val.enterpriseVersion >= 100){
                this.getPriceShow()
            }else {
                this.allowCostPrice = this.$store.state.power.allowCostPrice == 'Y'
            }
            unwatch()
        })
    },
    methods: {
        // 列宽：优先取元信息，未登记的列不设宽（自适应）
        getColumnWidth(prop) {
            const meta = this.customColumnMeta[prop]
            return meta && meta.width ? meta.width : ''
        },
        // 默认顺序：元信息 index；未登记的列排在最后
        getMetaIndex(prop) {
            const meta = this.customColumnMeta[prop]
            return meta && typeof meta.index === 'number' ? meta.index : 999
        },
        // async getTableColumn() {
        //     const { data: res } = await this.$http.post('/Account/saleCollectVue/saleCollectQueryColumn.html', this.Qs.stringify(this.params))
        //     if (res.code != 'success') return false
        //     res.result = JSON.parse(res.result)
        //     console.log(JSON.parse(res.result.data))
        //     this.tableColumnList = JSON.parse(res.result.data)
        // },
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            this.allowCostPrice = res.result == 'Y'
            console.log(this.allowCostPrice)
        },
        async getTableList() {
            // this.tableList = [
            //     { salesmanID: "82",salesmanName: "13525575787" },
            //     { brandID: "2022103111052600001",brandName: "统一" }
            // ]
            if(!this.params.code){
                return false
            }
            this.tableIsLoading = true
            const { data: res } = await this.$post(this.params.url, this.params)
            this.$message.closeAll()
            if (res.code != '0') {
                this.tableList = []
                this.total = 0
                this.summaries = {}
                this.tableIsLoading = false
                return this.$message.error(res.message)
            }
            let arr = []
            let result = res.data.resultList.map(item => {
                if (item.largessList && item.largessList.length > 0) {
                    item.largessList.forEach(it => {
                        arr.push(it)
                        item[it.prop] = it.value
                    })
                }
                return item
            })
            const newObj = {}
            const newObjArray = []
            arr.forEach((element) => {
                if (!newObj[element.name]) {
                    newObjArray.push({
                        label: element.name,
                        prop: element.prop
                    });
                    newObj[element.name] = true;
                }
            })
            this.isLargessList = newObjArray
            this.tableList = result
            this.total = res.data.total
            this.summaries = res.data.sumData ? res.data.sumData : {}
            this.tableIsLoading = false
        },
        async getCustomColumnsList() {
            // let tempArr = this.customColumnsList.map((item, index) => {
            //     let _id = index + ''
            //     return {
            //         prop: item.prop,
            //         id: _id,
            //         isShow: "Y"
            //     }
            // }).filter(item => (item.prop))
            // console.log(tempArr)
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: this.funcCode })
            );
            if (res.code != "success")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            let result = JSON.parse(res.result);
            let tempArr = [];
            let arr = [];
            this.customColumnsList.some((item) => {
                // if (item.power && !item.power.every((row) => this.$store.state.power[row] == "Y"))
                //     return false;
                if (item.power && !this.allowCostPrice)
                    return false;
                tempArr.push(item);
            });
            tempArr.forEach((item) => {
                // 后端模板已登记的列：按模板 isShow 显示
                let matched = result.find(($item) => item.prop == $item.prop)
                if (matched) {
                    arr.push({
                        id: matched.id,
                        label: item.label,
                        prop: item.prop,
                        isShow: matched.isShow,
                        // 携带用户拖动保存的顺序，供列渲染排序使用（为空表示未拖动过，走默认顺序）
                        sort: typeof matched.sort === 'number' ? matched.sort : null,
                    });
                } else {
                    // 后端模板未登记的新列（需求#154）：加入自定义列配置，默认隐藏，用户勾选后显示
                    arr.push({
                        id: '',
                        label: item.label,
                        prop: item.prop,
                        isShow: 'N',
                    });
                }
            });
            this.customColumn = [...arr]
        },
        getSummaries(param) {
            const { columns } = param
            const sums = [];
            for (let key in this.summaries) {
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = '合计'
                        return
                    }
                    if (column.property == key) {
                        sums[index] = this.summaries[key]
                        return
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs[this.tag].doLayout();
            })
            return sums
        },
        handleSizeChange(newSize) {
            this.params.size = newSize
            this.getTableList()
        },
        handleCurrentChange(newPage) {
            this.params.page = newPage
            this.getTableList()
        },
        getCustomColumns() {
            // console.log(this.$refs[this.tag])
            this.$emit("columns", this.customColumn);
        },
        sortChange({ prop, order }) {
            console.log(prop, order)

            let orderStr = ''
            if (order == 'descending') {
                orderStr = 'DESC'
            } else if (order == 'ascending') {
                orderStr = 'ASC'
            }
            let propStr = prop
            if (prop.indexOf('Qty') > -1) propStr = prop.replace('Qty', 'OrderQty')
            this.params.sortField = propStr.split('/')[0]
            this.params.sortBy = orderStr

            if(prop === 'saleDetailSalQtyFormat' || prop === 'backDetailSalQtyFormat'|| prop === 'returnDetailSalQtyFormat' || prop === 'netSalQtyFormat' || prop === 'netInvQtyFormat') {
                this.params.sortField = prop.replace('Format', 'Order')
            }
            if(prop === 'backDetailInvQtyFormat' || prop === 'returnDetailInvQtyFormat' || prop === 'saleDetailInvQtyFormat') {
                this.params.sortField = prop.split('Format')[0]
            }

            if(prop === 'crossProfitMargin') {
                this.params.sortField = 'crossProfitOrderMargin'
            }
            if(prop === 'returnLv') {
                this.params.sortField = 'returnLvOrderQty'
            }

            if(prop === 'returnMeetLv') {
                this.params.sortField = 'returnMeetLvOrderQty'
            }

            if(prop === 'exchangeMeetQty') {
                this.params.sortField = 'exchangeMeetOrderQty'
            }

            this.getTableList()
        },
        exportTableExcel(flag) {
            let obj = { ...this.params }
            delete obj.url
            let exportExcelUrl = '/erpnew/account/c/reada46ceb/sale/collect/queryExcelReport.html'
            let tempArr = []
            this.tableHeaderList.forEach(item => {
                tempArr.push({
                    label: item.label,
                    prop: item.prop
                })
            })
            this.customColumn.forEach(item => {
                if (item.isShow == 'Y') {
                    tempArr.push({
                        label: item.label,
                        prop: item.prop
                    })
                }
            })
            if(flag == 'Y'){
              obj.isSplit = 'Y'
            }
            exportExcelCommonForVue(obj, tempArr, exportExcelUrl)
        },
        jumpDetails(row) {
            this.$emit('onSubmit')
            // 根据算选的 商品   ，筛选右侧选项框的 查询条件
            // console.log(row)
            for(let i in row) {
                Object.keys(this.transmitQuery).map((key) => {
                    if(row[i] && i === this.transmitQuery[key].submitName) {
                        // 需求#154：selected 为字符串的单选字段（customerLevel/customerStatus/productClassification 等）直接跳过，
                        // 避免被转成对象数组，导致销售明细表(新) 页面显示 [object Object]
                        if(!Array.isArray(this.transmitQuery[key].selected)) {
                            return
                        }
                        let arr = []
                        if(this.transmitQuery[key].selected.length) {
                            arr = this.transmitQuery[key].selected.filter(item => { return item.value === row[i] }) 
                        } else {
                            let str = i.replace('ID','Name')
                            let obj = { value: row[i], text: row[str] }
                            arr.push(obj)
                            if(i === 'itemID' || i === 'customerID') {
                                this.transmitQuery[key].list = arr
                            }
                        }
                        this.transmitQuery[key].selected = arr
                    }
                })
            }
            //清欠情况
            for (let i in this.transmitQuery) {
                if(this.transmitQuery[i].submitName == 'arrearType'){
                    if(this.transmitQuery[i].selected.length > 0) {
                        let arr1 = this.transmitQuery[i].selected.filter(it => it == 'C' || it == 'D')
                        let arr2 = this.transmitQuery[i].selected.filter(it => !(it == 'C' || it == 'D'))
                        console.log(arr2, arr1)
                        if(arr1.length > 0) {
                            this.transmitQuery[i].selected = [...arr2, ...['C']]
                        }
                    }
                }
            }
            console.log(this.transmitQuery)
            let width = window.top.document.browser.availiframeWidth.value
            let height = window.top.document.browser.availiframeHeight.value
            let timestemp = new Date().getTime()
            this.transmitQuery.timestemp = timestemp
            top.addPanel('销售明细表(新)', `/templates/vue-account/dist/index.htm#/commodityDetails?type=1&timestemp=${timestemp}`, width, height, true, this.transmitQuery)
        }
    }
}
</script>
<style type="text/css" src="@/assets/font/pcFont/iconfont.css"></style>
<style scoped lang="less">
.table-content {
    height: calc(100% - 4px);
}

.table {
    height: calc(100% - 32px);

    /deep/.el-table {

        td,
        th {
            padding: 6px 0;
        }
    }
    /deep/ .el-table--scrollable-x .el-table__body-wrapper{
        z-index: 2;
    }
}
</style>